// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 4V2H5V4L19 4ZM21 7.5L3 7.5V5.5L21 5.5V7.5ZM23 9V22H1V9L23 9Z"}}]};

const CollectionFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collection-filled',
    ref,
    icon: element,
  },
));

CollectionFilledIcon.displayName = 'CollectionFilledIcon';

export default CollectionFilledIcon;
